import Base from "./Base";
import {Typography} from "@mui/material";
import GeneralStepper from "../components/GeneralStepper";
import GeneralData from "./cart/GeneralData";
import BillingFormTabs from "./cart/BillingTabs";
import {useContext, useRef, useState} from "react";
import PaymentData from "./cart/PaymentData";
import useCallDataApi from "../hooks/data";
import {getSubdomain} from "../utils/Utils";
import {emptyCart, loadCartFromLocalStorage} from "../utils/cart";
import Loading from "../components/Loading";
import Summary from "./cart/Summary";
import ConfigContext from "../context/ConfigContext";
import {useSnackbar} from "notistack";

const Checkout = () => {
    const {config} = useContext(ConfigContext)
    const {postData: postOrder} = useCallDataApi('sp-order')
    const [data, setData] = useState({
        phone: '+36',
        payment: 'card'
    })
    const [loading, setLoading] = useState(false)
    const generalRef = useRef(null)
    const personBillingRef = useRef(null)
    const companyBillingRef = useRef(null)
    const paymentRef = useRef(null)
    const [accept, setAccept] = useState(false)
    const {enqueueSnackbar} = useSnackbar()

    const validateGeneral = () => {
        const data = generalRef.current.getData()
        return !!data;
    }

    const validateBilling = () => {
        const personData = personBillingRef.current?.getData()
        const companyData = companyBillingRef.current?.getData()
        return personData || companyData
    }

    const validatePayment = () => {
        const paymentData = paymentRef.current?.getData()
        return !!paymentData
    }

    const validateAccepted = () => {
        if (!accept) {
            enqueueSnackbar("A rendlés leadásához el kell fogadni az adatvédelmi nyilatkozatot!", {variant: "warning"})
        }
        return accept
    }

    const placeOrder = () => {
        setLoading(true)
        postOrder('place_order/', {
            ...data,
            subdomain: getSubdomain(),
            ordered_products: loadCartFromLocalStorage()
        })
            .then(r => {
                emptyCart()
                window.location.href = r?.data?.redirect_link
            })
            .finally(() => setLoading(false))
    }

    const personalDataStep = {
        label: 'Személyes adatok',
        component: <GeneralData data={data} setData={setData} reference={generalRef}/>,
        validate: validateGeneral
    };
    const billingDataStep = {
        label: 'Számlázási adatok',
        component: <BillingFormTabs data={data} setData={setData} personReference={personBillingRef}
                                    companyReference={companyBillingRef}/>,
        validate: validateBilling
    };
    const paymentDataStep = {
        label: 'Fizetési adatok',
        component: <PaymentData data={data} setData={setData} reference={paymentRef}/>,
        validate: validatePayment
    };
    const summaryStep = {
        label: 'Összesítő',
        component: <Summary accept={accept} setAccept={setAccept} data={data}/>,
        validate: validateAccepted
    };
    const billingDetailsMandatory =  ['mandatory', 'optional'].includes(config?.mandatory_billing_details);
    const newOrderSteps = []
    newOrderSteps.push(personalDataStep)
    if (billingDetailsMandatory) {
        newOrderSteps.push(billingDataStep)
    }
    newOrderSteps.push(paymentDataStep)
    newOrderSteps.push(summaryStep)

    return <Base hideCart>
        <div className="services-container">
            <div className="white-card">
                <Typography variant='headline6'>Rendelés leadása</Typography>
                <Typography variant='body2' color='#536B74'>Kérjük adja meg az alábbi adatokat a rendelés
                    véglegesítéséhez</Typography>
                <GeneralStepper steps={newOrderSteps} onFinish={placeOrder} finishText='Rendelés leadása'/>
            </div>
        </div>

        <Loading isLoading={loading}/>
    </Base>
}

export default Checkout